/*
 * Protect It – Package Protection ($1.99, SKU VG-PROTECT-199)
 * Vagy Rejuvenation
 *
 * - Adds the protection automatically once the cart has at least one other product.
 * - Keeps it at exactly one unit (no duplicates when the cart or quantities change).
 * - If the customer removes it, it is NOT added back for that cart, and the cart
 *   attribute "Protect It" = "Removed by customer" is saved so it reaches the order.
 * - Removes the protection if it is the only thing left in the cart.
 *
 * Config comes from snippets/protect-it.liquid (window.ProtectItConfig).
 */
(function () {
  'use strict';
 
  if (window.__protectItLoaded) return;
  window.__protectItLoaded = true;
 
  var C = window.ProtectItConfig || {};
  var VID = Number(C.variantId);
  if (!VID) return;
 
  var ROOT = String(C.root || '/').replace(/\/?$/, '/');
  var ATTR = 'Protect It';
  var VAL_ADDED = 'Added';
  var VAL_REMOVED = 'Removed by customer';
  var KEY_OPTOUT = 'protectIt_optOut'; // value = cart token the customer opted out on
  var KEY_SEEN = 'protectIt_seen';     // value = cart token that last had protection
 
  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var queued = false;
  var timer = null;
 
  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function del(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
 
  function request(path, body) {
    var opts = {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    };
    if (body) opts.body = JSON.stringify(body);
    return nativeFetch(ROOT + path, opts).then(function (r) {
      if (!r.ok) throw new Error('Protect It: ' + path + ' ' + r.status);
      return r.json();
    });
  }
 
  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }
 
  function refreshUI(cart) {
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    try {
      if (window.theme && typeof window.theme.updateCartDrawer === 'function') {
        window.theme.updateCartDrawer(cart);
      } else {
        document.documentElement.dispatchEvent(
          new CustomEvent('wetheme-cart-update', { detail: { cart: cart } })
        );
      }
    } catch (e) {}
    // Rebuy Smart Cart (the store's cart drawer) keeps its own copy of the cart.
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') {
        window.Rebuy.Cart.fetchCart();
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('protect-it:updated', { detail: { cart: cart } }));
    } catch (e) {}
  }
 
  function sync() {
    if (running) { queued = true; return Promise.resolve(); }
    running = true;
    var changed = false;
 
    return request('cart.js')
      .then(function (cart) {
        var token = cart.token || 'no-token';
        var attrs = cart.attributes || {};
        var protLines = [];
        var others = 0;
        cart.items.forEach(function (it) {
          if (Number(it.variant_id) === VID) protLines.push(it);
          else others += it.quantity;
        });
        var protQty = protLines.reduce(function (s, it) { return s + it.quantity; }, 0);
        var wasIn = get(KEY_SEEN) === token;
        var optedOut = get(KEY_OPTOUT) === token || attrs[ATTR] === VAL_REMOVED;
 
        // 1) Nothing else in the cart -> protection should not be there.
        if (others === 0) {
          del(KEY_SEEN);
          if (protQty > 0) {
            var clear = {};
            protLines.forEach(function (it) { clear[it.key] = 0; });
            changed = true;
            return request('cart/update.js', { updates: clear });
          }
          return cart;
        }
 
        // 2) Protection missing.
        if (protQty === 0) {
          if (wasIn || optedOut) {
            // Customer removed it -> remember and never re-add on this cart.
            set(KEY_OPTOUT, token);
            del(KEY_SEEN);
            if (attrs[ATTR] !== VAL_REMOVED) {
              return request('cart/update.js', { attributes: { 'Protect It': VAL_REMOVED } });
            }
            return cart;
          }
          changed = true;
          return request('cart/add.js', { items: [{ id: VID, quantity: 1 }] }).then(function () {
            set(KEY_SEEN, token);
            return request('cart/update.js', { attributes: { 'Protect It': VAL_ADDED } });
          });
        }
 
        // 3) Protection present: keep exactly one unit on one line.
        set(KEY_SEEN, token);
        if (get(KEY_OPTOUT) === token) del(KEY_OPTOUT); // customer re-added it manually
        var updates = {};
        var needFix = protQty !== 1 || protLines.length !== 1;
        protLines.forEach(function (it, i) { updates[it.key] = i === 0 ? 1 : 0; });
        var body = {};
        if (needFix) { body.updates = updates; changed = true; }
        if (attrs[ATTR] !== VAL_ADDED) body.attributes = { 'Protect It': VAL_ADDED };
        if (body.updates || body.attributes) return request('cart/update.js', body);
        return cart;
      })
      .then(function (cart) {
        if (changed) return request('cart.js').then(refreshUI);
        return cart;
      })
      .catch(function (err) {
        if (window.console) console.warn(err);
      })
      .then(function () {
        running = false;
        if (queued) { queued = false; schedule(); }
      });
  }
 
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }
 
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
 
  function urlOf(input) {
    if (!input) return '';
    if (typeof input === 'string') return input;
    return input.url || String(input);
  }
 
  // Watch the theme's (and apps') cart requests.
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    if (CART_MUTATION.test(urlOf(input))) {
      p.then(schedule, schedule);
    }
    return p;
  };
 
  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__protectItWatch = CART_MUTATION.test(String(url || ''));
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__protectItWatch) this.addEventListener('loadend', schedule);
    return xSend.apply(this, arguments);
  };
 
  // Form-based cart (non-AJAX) and first page load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
 
  window.ProtectIt = { sync: sync };
})();
 